// extracted by mini-css-extract-plugin
export var background = "_5h-0";
export var container = "_5h-1";
export var contentItem = "_5h-7";
export var extendedWarranty = "_5h-5";
export var link = "_5h-d";
export var modal = "_5h-b";
export var modalCloseButton = "_5h-9";
export var modalContent = "_5h-3";
export var modalContentMain = "_5h-6";
export var modalImageLogo = "_5h-8";
export var modalLogo = "_5h-a";
export var modalSideImage = "_5h-4";
export var preview = "_5h-c";
export var redoModal = "_5h-2";